import React from 'react';
import '../styles/StrengthActivityModal.css';
import { useTranslation } from '../../i18n';

const PlannedVsCompletedStrength = ({ planned = {}, completed = {}, setPlanned }) => {
  const { t } = useTranslation();

  const metrics = [
    { label: t('strength.duration'),     key: 'duracion',     unit: 'h:mm:ss' },
    { label: t('strength.repetitions'),  key: 'repeticiones', unit: ''        },
    { label: t('strength.sets'),         key: 'series',       unit: ''        },
    { label: t('strength.caloriesField'),key: 'calorias',     unit: 'kcal'    },
    { label: t('strength.te'),           key: 'te',           unit: ''        },
    { label: 'TEA',                      key: 'tea',          unit: ''        },
    { label: 'TSS',                      key: 'tss',          unit: ''        },
  ];

  const handleChange = (key, value) => setPlanned({ ...planned, [key]: value });

  const formatCompletedValue = (key, value) => {
    if (value === undefined || value === null || value === '') return '';
    if (key === 'duracion') {
      const totalSeconds = parseFloat(value);
      if (isNaN(totalSeconds)) return '';
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = Math.floor(totalSeconds % 60);
      return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    if (key === 'te' || key === 'tea') {
      if (value === '-' || value === '') return '';
      const parsed = parseFloat(value);
      return isNaN(parsed) ? '' : parsed.toFixed(1);
    }
    if (key === 'tss') {
      const parsed = parseFloat(value);
      return isNaN(parsed) ? '' : parsed.toFixed(2);
    }
    return value;
  };

  return (
    <div className="metrics-box">
      <div className="metrics-title">{t('strength.plannedVsCompleted')}</div>
      <table className="table metrics-table">
        <thead>
          <tr>
            <th>{t('strength.metric')}</th>
            <th>{t('strength.planned')}</th>
            <th>{t('strength.completed')}</th>
            <th>{t('strength.unit')}</th>
          </tr>
        </thead>
        <tbody>
          {metrics.map(({ label, key, unit }) => (
            <tr key={key}>
              <td>{label}</td>
              <td>
                <input type="text" className="form-control" value={planned[key] || ''} onChange={(e) => handleChange(key, e.target.value)} />
              </td>
              <td>
                <input type="text" className="form-control" value={formatCompletedValue(key, completed[key])} readOnly />
              </td>
              <td>{unit}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlannedVsCompletedStrength;
